import React from 'react'
import {PrimaryButton} from '../../../core/components/unilink/index'
import noLeaves from '../../../core/img/no-leafs.svg'
import './noLessons.css'

class NoLessons extends React.PureComponent {

  render() {
    const {withColor} = this.props
    return (
      <div className='gridcontainer'>
        <div className='no-lessons'>
          <div className='no-lessons__container'>
            <img src={noLeaves} alt="" />
            <h3> This topic has no lessons yet...</h3>
            <span>Find another topic with search <br />or view subjects to explore</span>
            <PrimaryButton className={`no-lessons__button topic-header__enter-gm--${withColor}`} to='/subjects'>
              View Subjects
            </PrimaryButton>
          </div>
        </div>
      </div>
    )
  }
}

export default NoLessons



// WEBPACK FOOTER //
// ./src/domains/topic/components/NoLessons.js